t = require('app/scripts/views/internal/teacup-with-helpers')('power_ups_voting_prefs')

module.exports = t.renderable ({ canChange, canSetObservers, canSetOrganization, canSetPublic, votingMode, hideVotes }) ->
  t.h4 ->
    t.format 'who-is-allowed-to-vote-on-cards'

  t.ul '.pop-over-list', ->

    t.li ->
      t.a '.js-voting-select', { href: '#', class: t.classify(disabled: !canChange), name: 'members' }, ->
        t.span '.name', ->
          t.format 'members'

        if votingMode == 'members'
          t.icon 'check'

        t.span '.sub-name', ->
          t.format 'admins-and-board-members-can-vote'

    t.li ->
      t.a '.js-voting-select', { href: '#', class: t.classify(disabled: !canChange || !canSetObservers), name: 'observers' }, ->

        t.span '.name', ->
          t.format 'members-and-observers'

        if votingMode == 'observers'
          t.icon 'check'

        t.span '.sub-name', ->
          t.format 'admins-board-members-and-observers-can-vote'

    t.li ->
      t.a '.js-voting-select', { href: '#', class: t.classify(disabled: !canChange || !canSetOrganization), name: 'org' }, ->

        t.span '.name', ->
          t.format 'organization-members'

        if votingMode == 'org'
          t.icon 'check'

        t.span '.sub-name', ->
          t.format 'admins-board-members-observers-and-team-members-can-vote'

    t.li ->
      t.a '.js-voting-select', { href: '#', class: t.classify(disabled: !canChange || !canSetPublic), name: 'public' }, ->

        t.span '.name', ->
          t.format 'public-members'

        if votingMode == 'public'
          t.icon 'check'

        t.span '.sub-name', ->
          t.format 'any-trello-user-can-vote'

  t.tag 'hr'

  t.h4 ->
    t.format 'hide-vote-counts'

  t.ul '.pop-over-list', ->
    t.li ->
      t.a '.js-vote-count-select', { href: '#', class: t.classify(disabled: !canChange), name: 'hideVoteCount' }, ->

        t.span '.name', ->
          t.format 'hide-vote-counts-except-mine'

        if hideVotes
          t.icon 'check'

        t.span '.sub-name', ->
          t.format 'hide-vote-counts-except-mine-explain'
